import classNames from 'classnames';
import { DetailedHTMLProps, InputHTMLAttributes, RefObject, useRef } from 'react';
import { getAssetUrl } from '../../../utils/config';
import useScrollToFirstInvalidField from '../../../utils/useScrollToFirstInvalidField';
import './style.scss';

export type CustomInputProps = {
  hasError?: boolean;
  hasSuccess?: boolean;
  isInputStatusIconDisabled?: boolean;
  toggleImage?: JSX.Element;
  inputref?: RefObject<HTMLInputElement>;
};

export type InputProps = CustomInputProps & DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

const Input = ({ className, hasError, hasSuccess, isInputStatusIconDisabled, toggleImage, ...props }: InputProps) => {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const inputRef = props.inputref ?? useRef<HTMLInputElement>(null);
  useScrollToFirstInvalidField(props.name!, inputRef);

  const inputClassNames = classNames(
    'input',
    {
      'input--error': hasError,
      'input--success': hasSuccess,
    },
    className
  );

  const labelClassNames = classNames('label', { 'label--value': props.value });

  const inputStatusIcon =
    isInputStatusIconDisabled || !(hasError || hasSuccess)
      ? undefined
      : hasError
      ? 'inputs/error.svg'
      : 'inputs/success.svg';

  return (
    <div className="float" style={{ position: toggleImage ? 'relative' : 'static' }}>
      <input
        className={inputClassNames}
        id={props.name}
        {...props}
        onChange={e => {
          e.persist();
          props.onChange?.(e);
          setTimeout(() => {
            if (!inputRef.current) {
              return;
            }
            const computedStyle = getComputedStyle(inputRef.current!);
            const isFirefoxAutofilled =
              computedStyle.getPropertyValue('filter') ===
              'grayscale(0.21) brightness(0.88) contrast(1.61) invert(0.1) sepia(0.4) saturate(2.06)';
            const isChromeAutofilled = computedStyle.getPropertyValue('appearance') === 'menulist-button';
            if (isChromeAutofilled || isFirefoxAutofilled) {
              props.onBlur?.(e as any);
            }
          }, 0);
        }}
        ref={inputRef}
        style={inputStatusIcon && { backgroundImage: `url('${getAssetUrl(inputStatusIcon)}')` }}
      />
      <label onClick={() => inputRef.current?.focus()} className={labelClassNames} htmlFor={props.name}>
        {props.placeholder}
      </label>
      {toggleImage && toggleImage}
    </div>
  );
};

export default Input;
